import { call, put } from 'redux-saga/effects';

export const setSelfChangedData$ = (model = '') =>
  `realtime/SET_SELF_CHANGED_DATA/${model.toUpperCase()}`;

export const setSelfChangedData = ({ data, model }) => ({
  type: setSelfChangedData$(model),
  payload: data,
});

export function* requestWithUpdateHandler({ model = '', endpoint, params = [] }) {
  const data = yield call(endpoint, ...params);

  yield put(
    setSelfChangedData({
      model,
      data,
    })
  );
}
